export type { AvatarProps } from './Avatar.types'
export { default as Avatar } from './Avatar'